var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTripadvisor = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 15,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#767571",
  d: "M7.45 8.178a1.95 1.95 0 1 1-3.9 0 1.95 1.95 0 0 1 3.9 0m9.045-1.95a1.95 1.95 0 1 0-.002 3.9 1.95 1.95 0 0 0 .003-3.9Zm5.5 1.95a5.5 5.5 0 0 1-9.235 4.034L11 14.128 9.239 12.21a5.498 5.498 0 1 1-7.44-8.094L0 2.159h3.997a12.46 12.46 0 0 1 14.016 0H22l-1.799 1.957a5.48 5.48 0 0 1 1.794 4.062m-12.773 0a3.72 3.72 0 1 0-7.44 0 3.72 3.72 0 0 0 7.44 0m5.906-5.554a10.74 10.74 0 0 0-8.257 0C9.219 3.524 11 5.623 11 8.071c0-2.448 1.78-4.548 4.128-5.447m5.088 5.554a3.72 3.72 0 1 0-7.44 0 3.72 3.72 0 0 0 7.44 0"
})));
export default SvgTripadvisor;